export const COMPANY = {
  name: 'Crystal Clean',
  slogan: 'Family Clean Company',
  tagline: 'Commercial & Residential Cleaning Services',
  phone: '239.936.7700',
  phoneHref: 'tel:2399367700',
  email: 'michael@cleaningfortm.com',
  address: '2420 Concorde Dr. #6, Fort Myers, FL 33901',
  addressNaples: '1281 Rail Head Lane, Naples, FL 34110',
  naplesPhone: '239.206.8817',
  since: '1980',
};

export const NAV_ITEMS = [
  { label: 'Home', href: '#home' },
  {
    label: 'Services',
    href: '#services',
    children: [
      { label: 'Janitorial Services', href: '#services' },
      { label: 'Condo Association Common Area Clean', href: '#services' },
      { label: 'Office Cleaning', href: '#services' },
      { label: 'Medical Office Cleaning', href: '#services' },
      { label: 'Construction Cleaning', href: '#services' },
      { label: 'Day Porter Services', href: '#services' },
      { label: 'Pressure Washing', href: '#services' },
      { label: 'Window Washing', href: '#services' },
      { label: 'Resort Turnover Cleaning', href: '#services' },
      { label: 'Hurricane and Storm Clean Up', href: '#services' },
      { label: 'Floor Care', href: '#services' },
    ],
  },
  { label: 'Request A Quote', href: '#quote' },
  {
    label: 'Jobs',
    href: '#jobs',
    children: [{ label: 'Accessibility Statement', href: '#jobs' }],
  },
  { label: 'Blog', href: '#news' },
  {
    label: 'Contact',
    href: '#contact',
    children: [
      { label: 'Fort Myers', href: '#contact' },
      { label: 'Naples', href: '#contact' },
    ],
  },
  {
    label: 'About',
    href: '#about',
    children: [
      { label: 'Clean Talk', href: '#news' },
      { label: 'Cleaning With Purpose Podcast', href: '#news' },
      { label: 'Reviews', href: '#testimonials' },
      { label: 'New Releases', href: '#news' },
    ],
  },
];

export const HERO_PHOTOS = [
  {
    src: 'https://readdy.ai/api/search-image?query=Professional%20cleaning%20staff%20member%20in%20uniform%20mopping%20the%20floor%20of%20a%20bright%20modern%20commercial%20lobby%2C%20natural%20daylight%2C%20clean%20airy%20interior%2C%20editorial%20photography%2C%20soft%20neutral%20tones&width=500&height=500&seq=cc-hero-01&orientation=squarish',
    alt: 'Cleaning the lobby floor',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Professional%20window%20cleaner%20using%20a%20squeegee%20on%20tall%20glass%20windows%20of%20a%20commercial%20building%2C%20bright%20blue%20sky%20reflection%2C%20clean%20uniform%2C%20daylight%2C%20editorial%20photography&width=500&height=500&seq=cc-hero-02&orientation=squarish',
    alt: 'Window washing',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Staff%20member%20pressure%20washing%20an%20outdoor%20paved%20walkway%20of%20a%20resort%2C%20spray%20of%20water%2C%20sunny%20tropical%20Florida%20setting%2C%20palm%20trees%2C%20editorial%20photography&width=500&height=500&seq=cc-hero-03&orientation=squarish',
    alt: 'Pressure washing',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Cleaning%20team%20vacuuming%20and%20wiping%20desks%20in%20a%20modern%20open%20plan%20office%2C%20bright%20windows%2C%20professional%20uniforms%2C%20clean%20minimal%20workplace%2C%20editorial%20photography&width=500&height=500&seq=cc-hero-04&orientation=squarish',
    alt: 'Office cleaning crew',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Friendly%20cleaning%20supervisor%20smiling%20while%20holding%20cleaning%20supplies%20in%20a%20commercial%20building%20hallway%2C%20professional%20uniform%2C%20bright%20airy%20space%2C%20editorial%20portrait&width=500&height=500&seq=cc-hero-05&orientation=squarish',
    alt: 'Crystal Clean supervisor',
  },
];

export const TESTIMONIALS = [
  {
    name: 'Sanibel Library',
    stars: 5,
    quote:
      'I wanted to send a direct note to express how much I personally appreciate the team assigned to clean the Sanibel Public Library. They are always kind, friendly, and do excellent work. Thank you so much for finding such quality staff for your team.',
  },
  {
    name: 'Lucaya Master',
    stars: 5,
    quote:
      'We are exceedingly happy with the services and their level of friendliness. Our Residents really appreciate all the efforts for our community at Lucaya in Fort Myers. Ask me about how clean our community grills are!!',
  },
  {
    name: 'Finemark Bank',
    stars: 5,
    quote:
      'Crystal Clean is a top tier cleaning company in SWFL. They are not the type of company that just goes through the motions. We could not be happier with our 3 story facility. 5 stars is just not enough!',
  },
  {
    name: 'AltaMar',
    stars: 5,
    quote:
      "We've been working with Crystal Clean for close to a year now, and the experience has been nothing short of EXCELLENT. The employee they have working at our association is consistently professional, reliable, and thorough.",
  },
];

export const SERVICES = [
  {
    title: 'Common Area Cleaning',
    image:
      'https://readdy.ai/api/search-image?query=Sparkling%20clean%20modern%20condominium%20common%20area%20with%20marble%20floors%2C%20elevators%20and%20hallways%2C%20bright%20natural%20light%2C%20tropical%20Florida%20interior%2C%20editorial%20photography&width=800&height=560&seq=cc-svc-common&orientation=landscape',
    description:
      'Common Area Cleaning keeps shared spaces in commercial buildings and residential properties clean, safe, and welcoming. Our team focuses on high-traffic areas such as lobbies, hallways, elevators, and entryways by dusting, vacuuming, mopping floors, and disinfecting high-touch surfaces. A consistently clean common area helps create a positive first impression for visitors and tenants.',
  },
  {
    title: 'HOA Cleaning',
    image:
      'https://readdy.ai/api/search-image?query=Clean%20clubhouse%20and%20pool%20area%20of%20a%20Florida%20homeowners%20association%2C%20fitness%20center%20and%20restrooms%20visible%2C%20sunny%20day%2C%20palm%20trees%2C%20editorial%20photography&width=800&height=560&seq=cc-svc-hoa&orientation=landscape',
    description:
      'Our HOA Cleaning services help homeowners associations maintain clean and well-presented community spaces. We service clubhouses, fitness centers, restrooms, hallways, and other shared areas to ensure residents and guests enjoy a spotless environment. Consistent cleaning helps preserve property value and enhances the overall appearance of the community.',
  },
  {
    title: 'Medical Cleaning',
    image:
      'https://readdy.ai/api/search-image?query=Sanitized%20bright%20medical%20office%20reception%20and%20patient%20area%2C%20spotless%20surfaces%2C%20clean%20white%20and%20blue%20tones%2C%20professional%20healthcare%20environment%2C%20editorial%20photography&width=800&height=560&seq=cc-svc-medical&orientation=landscape',
    description:
      'Medical Cleaning focuses on maintaining high sanitation standards in healthcare environments. Our trained team disinfects high-touch surfaces, patient areas, and common spaces using proper cleaning protocols. This helps reduce the spread of germs and creates a safer environment for patients, staff, and visitors.',
  },
  {
    title: 'Post Construction Cleaning',
    image:
      'https://readdy.ai/api/search-image?query=Post%20construction%20cleaning%20of%20a%20newly%20renovated%20bright%20commercial%20space%2C%20clean%20floors%20and%20glass%2C%20dust%20free%20surfaces%2C%20daylight%2C%20editorial%20photography&width=800&height=560&seq=cc-svc-construction&orientation=landscape',
    description:
      'Post Construction Cleaning removes dust, debris, and residue left behind after construction or renovation projects. Our team performs detailed cleaning of floors, windows, surfaces, and fixtures to prepare the space for occupancy. We turn newly built or remodeled spaces into clean, move-in-ready environments.',
  },
];

export const TRUSTED_IMAGES = [
  {
    src: 'https://readdy.ai/api/search-image?query=Pressure%20washing%20crew%20cleaning%20an%20outdoor%20building%20facade%2C%20spray%20of%20water%2C%20sunny%20day%2C%20tropical%20Florida%2C%20editorial%20photography&width=400&height=400&seq=cc-trust-01&orientation=squarish',
    alt: 'Pressure washing team',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Staff%20member%20operating%20a%20floor%20scrubber%20machine%20in%20a%20large%20commercial%20hallway%2C%20bright%20reflections%2C%20clean%20uniform%2C%20editorial%20photography&width=400&height=400&seq=cc-trust-02&orientation=squarish',
    alt: 'Floor scrubbing',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Cleaning%20a%20gleaming%20lobby%20floor%20with%20a%20mop%20and%20bucket%2C%20bright%20modern%20building%2C%20daylight%2C%20editorial%20photography&width=400&height=400&seq=cc-trust-03&orientation=squarish',
    alt: 'Mop and bucket',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Professional%20cleaning%20team%20posing%20in%20front%20of%20a%20white%20service%20van%20in%20a%20sunny%20parking%20lot%2C%20uniforms%2C%20tropical%20Florida%20setting%2C%20editorial%20photography&width=400&height=400&seq=cc-trust-04&orientation=squarish',
    alt: 'Crystal Clean team',
  },
];

export const COVERAGE_CITIES = [
  'Fort Myers',
  'Estero',
  'Bonita Springs',
  'Cape Coral',
  'Lehigh Acres',
  'Naples',
  'Fort Myers Beach',
  'Sanibel',
  'Labelle',
  'Pine Island',
  'Punta Gorda',
  'Immokalee',
];

export const PARTNERS = ['CRC', 'ISSA', 'BSCAI', 'CAI', 'SWFL Inc.', 'CCCA'];

export const NEWS_ITEMS = [
  {
    tag: 'Clean Talk',
    title: 'Hurricane Prep',
    text: 'Stay ahead of storm season. Our crews help communities prepare, respond, and recover with reliable storm clean-up and property care across Southwest Florida.',
  },
  {
    tag: 'Cleaning With Purpose',
    title: 'Community Impact',
    text: 'For over 45 years we have invested in our people and the neighborhoods we serve — building a team of 120+ local professionals who take pride in every space.',
  },
];

export const BUSINESS_HOURS = [
  { day: 'Monday - Friday', time: '8 am – 5 pm' },
  { day: 'Saturday', time: 'Closed' },
  { day: 'Sunday', time: 'Closed' },
];